export enum ToasterDelay {
  SHORT = 2000,
  DEFAULT = 4000,
  LONG = 8000,
}

export enum CloseAnimationDelay {
  SHORT = 100,
  DEFAULT = 300,
  LONG = 600,
}
